interface MeetTheLeadersProps {
  onBookLeader: (leaderName: string) => void;
}

export default function MeetTheLeaders({ onBookLeader }: MeetTheLeadersProps) {
  const leaders = [
    {
      name: 'Sarah Mitchell',
      title: 'Chief AI Strategy Officer',
      credential: '20+ years enterprise transformation',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20confident%20female%20executive%20in%20her%2050s%20wearing%20elegant%20navy%20blazer%20neutral%20gray%20background%20corporate%20portrait%20photography%20warm%20lighting%20approachable%20expression&width=400&height=400&seq=leader-1&orientation=squarish'
    },
    {
      name: 'David Chen',
      title: 'VP of AI Engineering',
      credential: '15+ years cloud & AI architecture',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20male%20technology%20executive%20in%20his%2040s%20wearing%20charcoal%20suit%20neutral%20gray%20background%20corporate%20portrait%20photography%20confident%20expression&width=400&height=400&seq=leader-2&orientation=squarish'
    },
    {
      name: 'Amira Hassan',
      title: 'Director of AI Governance',
      credential: '12+ years regulatory compliance',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Middle%20Eastern%20female%20executive%20in%20her%2040s%20wearing%20sophisticated%20black%20blazer%20neutral%20gray%20background%20corporate%20portrait%20photography%20professional%20expression&width=400&height=400&seq=leader-3&orientation=squarish'
    }
  ];

  return (
    <section id="leaders" className="py-24 bg-[#f8f7f5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#1e3a8a] font-semibold text-sm tracking-wider uppercase mb-4">Booth TFG 28</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Meet the Leaders Driving AI at Scale
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Schedule a dedicated 30-minute meeting with our experts at the summit.
          </p>
        </div>

        {/* Leaders Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {leaders.map((leader, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-32 h-32 mx-auto mb-5 rounded-full overflow-hidden border-4 border-white shadow-lg">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-1">{leader.name}</h3>
              <p className="text-[#1e3a8a] font-medium text-sm mb-2">{leader.title}</p>
              <p className="text-gray-500 text-xs mb-5">{leader.credential}</p>
              <button
                onClick={() => onBookLeader(leader.name)}
                className="w-full px-4 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Book 1:1 Meeting
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
